import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { isNull, isUndefined } from 'lodash';

import { Loading, LoadingError } from '@components/Base';
import HeaderSecondary from '@components/HeaderSecondary';
import { HealthQuotePremiumCardBody } from '@components/Feature/HealthQuote';
import HealthQuotePaymentForm, { FormValues } from '@components/HealthQuotePaymentForm';

import { paymentTransactionCreate, PaymentTransactionCreatePayload } from './action';
import { useBillingFetch, useCancerQuoteFetch } from './hook';
import { selectCancerQuotePaymentPage } from './selector';

const CancerQuotePaymentPage = () => {
  const dispatch = useDispatch();
  const cancerQuote = useCancerQuoteFetch();
  const billing = useBillingFetch();
  const { paymentTransaction } = useSelector(selectCancerQuotePaymentPage);

  if (isUndefined(cancerQuote) || isUndefined(billing)) return <Loading />;
  if (isNull(cancerQuote) || isNull(billing)) return <LoadingError />;

  const { cancerPlanName } = cancerQuote;
  const { chargeAmount, chargeAmountKhr } = billing;

  const handleSubmit = (values: FormValues) => {
    const payload: PaymentTransactionCreatePayload = { billingId: billing.id, ...values };
    dispatch(paymentTransactionCreate(payload));
  };

  return (
    <>
      <HeaderSecondary />
      <Container className="my-3">
        <Row>
          <Col lg={8} className="mx-auto">
            <Card>
              <HealthQuotePremiumCardBody
                {...cancerQuote}
                totalPremium={chargeAmount}
                totalPremiumKhr={chargeAmountKhr}
                planName={cancerPlanName} />

              <Card.Body>
                <HealthQuotePaymentForm onSubmit={handleSubmit} paymentTransaction={paymentTransaction} />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export { CancerQuotePaymentPage };
